import axios from 'axios';

import { disableAutoBoundsSearching } from './coordinates';
import { changeRecords } from './search';
import { propertyFromApi } from 'bundles/research/property_api';

export const SWITCH_TAB = 'SWITCH_TAB';
export function switchTab(tab) {
  return { type: SWITCH_TAB, tab };
}

export const SWITCH_VIEW = 'SWITCH_COMP_INDEX_VIEW';
export const switchViewToList = () => ({ type: SWITCH_VIEW, view: 'list' });
export const switchViewToMap = () => ({ type: SWITCH_VIEW, view: 'map' });

export const SHOW_MAP_INFO_BUBBLE = 'SHOW_MAP_INFO_BUBBLE';
export function showMapInfoBubble(comp, att) {
  switch (att) {
  case 'leases':
    return { leases: comp, type: SHOW_MAP_INFO_BUBBLE };
  case 'sales':
    return { sales: comp, type: SHOW_MAP_INFO_BUBBLE };
  default:
    return { comp, type: SHOW_MAP_INFO_BUBBLE };
  }
}

export function selectCompMarker(compId) {
  return (dispatch, getState) => {
    const { ui, search } = getState();
    const tabLease = ui.currentTab === 'lease';
    const comps = tabLease ? search.leases : search.sales;
    const compUrl = tabLease ? 'leases' : 'sales';
    let comp = comps.find(comp => comp.id === compId);

    // Showing the info bubble may or may not change the bounds - don't research either way
    dispatch(disableAutoBoundsSearching());

    if (comp == null) {
      dispatch(showMapInfoBubble(null));
      return axios.get(`/research/${compUrl}/${compId}.json`).then((response) => {
        comp = propertyFromApi(response.data.property);
        comp.showPath = comp.propertyUrl;
        const meta = search.meta;
        if (tabLease) {
          const sales = search.sales;
          const leases = [...comps, comp];
          dispatch(changeRecords(sales, leases, meta));
          dispatch(showMapInfoBubble(comp, 'leases'));
        } else {
          const leases = search.leases;
          const sales = [...comps, comp];
          dispatch(changeRecords(sales, leases, meta));
          dispatch(showMapInfoBubble(comp, 'sales'));
        }
      });
    } else {
      comp.showPath = comp.propertyUrl;
      tabLease ? dispatch(showMapInfoBubble(comp, 'leases')) : dispatch(showMapInfoBubble(comp, 'sales'));
    }
  };
}

export const TOGGLE_MAP_LIST = 'TOGGLE_MAP_LIST';
export function toggleMapList() {
  return { type: TOGGLE_MAP_LIST };
}

export const HIDE_MAP_INFO_BUBBLE = 'HIDE_MAP_INFO_BUBBLE';
export function hideMapInfoBubble() {
  return { type: HIDE_MAP_INFO_BUBBLE };
}

export const TOGGLE_ALERT = 'TOGGLE_ALERT';
export function toggleAlert(message, error) {
  return { message, error, type: TOGGLE_ALERT };
}

export const SHOW_OVERLAY_FILTERS = 'SHOW_OVERLAY_FILTERS';
export function showOverlayFilters() {
  return ({ type: SHOW_OVERLAY_FILTERS });
}

export const HIDE_OVERLAY_FILTERS = 'HIDE_OVERLAY_FILTERS';
export function hideOverlayFilters() {
  return ({ type: HIDE_OVERLAY_FILTERS });
}
